import * as React from "react"
import type { IconProps } from "../types"

const MagnifyingGlassMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={1.5}
          d="M13.3332 13.3333L10.6998 10.7M11.9998 7.33329C11.9998 9.91062 9.9105 12 7.33317 12C4.75584 12 2.6665 9.91062 2.6665 7.33329C2.6665 4.75596 4.75584 2.66663 7.33317 2.66663C9.9105 2.66663 11.9998 4.75596 11.9998 7.33329Z"
        />
      </svg>
    )
  }
)
MagnifyingGlassMini.displayName = "MagnifyingGlassMini"

export default MagnifyingGlassMini
